import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ApiError } from 'openapi-typescript-fetch'
import { type LicensedEstablishmentUser } from 'src/types/api'
import { useApiMutation } from 'hooks/useApiMutation'
import { useJJConnectUserSchema } from 'pages/ClientManagement/LEConnectUsersPage/useJJConnectUserSchema'

interface UsePostJJConnectUserProps {
  onSuccess?: (data: LicensedEstablishmentUser) => void | Promise<void>
  onError?: (error: ApiError) => void
}

export const usePostJJConnectUser = ({
  onSuccess,
  onError,
}: UsePostJJConnectUserProps) => {
  const post = useTypedApiClient({
    path: '/admin/licensed-establishments/users',
    method: 'post',
  })
  const { schema } = useJJConnectUserSchema()

  return useApiMutation<typeof post, typeof schema>({
    mutationFn: async (formData) => {
      const { data } = await post({
        email: formData.email,
        firstName: formData.firstName,
        lastName: formData.lastName,
        type: 'Staff',
        corporateAccountId: formData.corporateAccountId ?? null,
        smartId: formData.smartId ?? null,
      })
      return data
    },
    onSuccess: async (result) => {
      await onSuccess?.(result as LicensedEstablishmentUser)
    },
    onError,
  })
}
